import React from "react";
import classNames from "classnames";
import { IconProps } from "../type";

export function ReturnArrowIcon({ className, style, ...props }: IconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={classNames(["h-full w-full", className])}
      style={style}
      viewBox='0 0 20 20'
      fill='none'
      {...props}
    >
      <path
        d='M7.50065 11.6663L3.33398 7.49967L7.50065 3.33301'
        stroke={style?.color ?? "#050530"}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M16.6673 16.6667V10.8333C16.6673 9.94928 16.3161 9.10143 15.691 8.47631C15.0659 7.85119 14.218 7.5 13.334 7.5H3.33398'
        stroke={style?.color ?? "#050530"}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
